import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function WeekChampionIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4199" data-mp="321q69v9k3mhz">
      <div className="relative w-full h-full bg-gradient-to-b from-indigo-900 to-purple-900 overflow-hidden" data-id="element-4200" data-mp="2s9al6p2yqhsv">
        {/* Background: Spotlight and Stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4201" data-mp="2n8mvc6qh0708">
          {/* Spotlight */}
          <path d="M100 0 L180 200 L20 200 Z" fill="url(#spotlight-grad)" opacity="0.4" data-id="element-4202" data-mp="2ebvr371rlluk" />
          {/* Stars */}
          <circle cx="40" cy="50" r="2" fill="#FDE047" data-id="element-4203" data-mp="20oks8wrhiszk" />
          <circle cx="160" cy="70" r="3" fill="#FDE047" data-id="element-4204" data-mp="25g2wpuspvbpa" />
          <circle cx="150" cy="30" r="1.5" fill="#FDE047" data-id="element-4205" data-mp="25hns1mmuuyo7" />
          <circle cx="60" cy="120" r="2" fill="#FDE047" data-id="element-4206" data-mp="1rp7qyrdilapx" />
          <circle cx="140" cy="140" r="1.5" fill="#FDE047" data-id="element-4207" data-mp="1rmldkb3y00zs" />

          <defs data-id="element-4208" data-mp="1wokfrhny4rv5">
            <linearGradient id="spotlight-grad" x1="100" y1="0" x2="100" y2="200" gradientUnits="userSpaceOnUse" data-id="element-4209" data-mp="1wo0w9windvf0">
              <stop offset="0%" stopColor="#FDE047" stopOpacity="0.8" data-id="element-4210" data-mp="2ocukohj7eezo" />
              <stop offset="100%" stopColor="#FDE047" stopOpacity="0" data-id="element-4211" data-mp="2aee4lzzgbc4v" />
            </linearGradient>
          </defs>
        </svg>

        {/* Background: Podium */}
        <svg className="absolute bottom-0 left-0 w-full h-1/3 z-0" viewBox="0 0 200 66" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-4212" data-mp="yzhe0lnmceve">
          <path d="M40 30 L160 30 L180 66 L20 66 Z" fill="#475569" data-id="element-4213" data-mp="jvxsq6q8ypj3" />
          <path d="M40 30 L160 30 L160 35 L40 35 Z" fill="#94A3B8" data-id="element-4214" data-mp="fvnph1tuad7x" />
          <path d="M60 45 L140 45 L145 66 L55 66 Z" fill="#334155" data-id="element-4215" data-mp="fxi7a79tdp7s" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-4216" data-mp="b2cdkma67695">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4217" data-mp="63hwppvrjrro">
            <DjaySpecimen look={{
            variant,
            accessory: 'trophy'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4218" data-mp="17ary0f3smbb" />
          </div>
        </div>

        {/* Foreground: Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4219" data-mp="1mjc69j0fjn3p">
            <rect x="30" y="80" width="6" height="12" fill="#EF4444" transform="rotate(45 30 80)" data-id="element-4220" data-mp="1p262akonmeas" />
            <rect x="170" y="100" width="8" height="8" fill="#3B82F6" transform="rotate(15 170 100)" data-id="element-4221" data-mp="1yuv93299f3zs" />
            <rect x="50" y="140" width="10" height="6" fill="#10B981" transform="rotate(-20 50 140)" data-id="element-4222" data-mp="1678vr2a8ckzq" />
            <rect x="150" y="160" width="6" height="10" fill="#F59E0B" transform="rotate(60 150 160)" data-id="element-4223" data-mp="1g2am21g8rt3w" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}